export interface ReportStateStatus {
  id: REPORT_STATE_STATUS;
  names: Record<string, string>;
}

export enum REPORT_STATE_STATUS {
  New = 0,
  InProgress = 1,
  Finished = 2,
  Failed = 3
}

export const REPORT_STATE_STATUS_DATA: ReportStateStatus[] = [
  {
    id: REPORT_STATE_STATUS.New,
    names: {
      'en-US': 'New',
      'ru-RU': 'Новая',
      'ar-LB': 'جديد',
      'uz-Latn-UZ': 'Yangi',
      'uz-Cyrl-UZ': 'Янги',
      'fr-FR': 'Nouveau'
    }
  },
  {
    id: REPORT_STATE_STATUS.InProgress,
    names: {
      'en-US': 'In progress',
      'ru-RU': 'В работе',
      'ar-LB': 'قيد التنفيذ',
      'uz-Latn-UZ': 'Jarayonda',
      'uz-Cyrl-UZ': 'Жараёнда',
      'fr-FR': 'En cours'
    }
  },
  {
    id: REPORT_STATE_STATUS.Finished,
    names: {
      'en-US': 'Finished',
      'ru-RU': 'Завершена',
      'ar-LB': 'منجز',
      'uz-Latn-UZ': 'Yakunlandi',
      'uz-Cyrl-UZ': 'Якунланди',
      'fr-FR': 'Terminé'
    }
  },
  {
    id: REPORT_STATE_STATUS.Failed,
    names: {
      "en-US": "Failed",
      "ru-RU": "Не удалось",
      "ar-LB": "فشل",
      "uz-Latn-UZ": "Muvaffaqiyatsiz",
      "uz-Cyrl-UZ": "Муваффақиятсиз",
      "fr-FR": "Échoué"
    }
  }

];

export const REPORT_STATE_ICON_STATUS: { [key: string]: string } = {
  [REPORT_STATE_STATUS.New]: '',
  [REPORT_STATE_STATUS.InProgress]: 'progress',
  [REPORT_STATE_STATUS.Finished]: 'pi-check',
  [REPORT_STATE_STATUS.Failed]: 'pi-times-circle',
};

export const REPORT_STATE_SEVERITY_STATUS: { [key: string]: string } = {
  [REPORT_STATE_STATUS.New]: 'info',
  [REPORT_STATE_STATUS.InProgress]: 'info',
  [REPORT_STATE_STATUS.Finished]: 'success',
  [REPORT_STATE_STATUS.Failed]: 'danger',
};
